import { render, staticRenderFns } from "./TheNotFound.vue?vue&type=template&id=ad1b402a&"
import script from "./TheNotFound.vue?vue&type=script&lang=js&"
export * from "./TheNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports